import './App.css';
import Header from './components/header';
import Hero from './components/hero';
import Second from './components/second';
import Third from './components/third';

function App() {
  return (
    <div className="App">
      <Header/>
      <Hero/>
      <Second/>
      <Third/>
    </div>
  );
}

export default App;
